import { render, staticRenderFns } from "./roleUsers.vue?vue&type=template&id=72fa4198&scoped=true"
import script from "./roleUsers.vue?vue&type=script&lang=js"
export * from "./roleUsers.vue?vue&type=script&lang=js"
import style0 from "./roleUsers.vue?vue&type=style&index=0&id=72fa4198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fa4198",
  null
  
)

export default component.exports